<div class="popup-background flex justify-content-center align-items-start">
  <div
    #innerPopup
    class="popup-box background-white flex flex-column margin-xxl--top-auto margin-xxl--bottom-auto"
    [ngStyle]="{ width: width + 'rem' }"
  >
    <div class="border--bottom-jobs padding-xxl-32 padding-xxl--top-20 padding-xxl--bottom-24">
      <p class="font--xxl-18 color-sky-blue margin-xxl--bottom-32 break-word margin-xxl--top-24">
        {{ message || 'Are you sure?' }}
      </p>
    </div>
    <div class="padding-xxl-32 flex align-items-center justify-content-end align-items-center">
      <div
        *ngIf="hasCancellationButton"
        class="margin-xxl--right-30 font--xxl-14 color-dark-blue cursor-pointer"
        (click)="closePopup()"
      >
        {{ cancelButtonLabel }}
      </div>
      <button
        (click)="closePopup(true)"
        class="button-round-medium color-dark-blue font--xxl-14 background-turquoise--dark border-z-green margin-xxl--left-18 flex align-items-center justify-content-center"
      >
        {{ confirmButtonLabel }}
      </button>
    </div>
  </div>
</div>
